$.fn.randomize = function(selector){
  var $elems = selector ? $(this).find(selector) : $(this).children(),
      $parents = $elems.parent();

  $parents.each(function(){
      $(this).children(selector).sort(function(){
          return Math.round(Math.random()) - 0.5;
      }).detach().appendTo(this);
  });

  return this;
};

// randomize the slides and then call slick
//$('.testimonial-slider').randomize('.testimonial-slide');


$('.testimonial-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1, 
    arrows: true,
    dots: true, 
  prevArrow: '<button type="button" class="slick-prev">&lt;</button>',
    nextArrow: '<button type="button" class="slick-next">&gt;</button>',
  swipeToSlide:true,
  touchThreshold:100,
    infinite: true,
    rows: 1, 
    responsive: [
        {
            breakpoint: 1000, 
            settings: {
                slidesToShow: 1, 
                slidesToScroll: 1 
            }
        }
    ]
});


$('.testimonial-sliders').slick({
    slidesToShow: 1,
    slidesToScroll: 1, 
    arrows: true, 
    dots: false, 
    prevArrow: '<button type="button" class="slick-prev">&lt;</button>',
    nextArrow: '<button type="button" class="slick-next">&gt;</button>',

    infinite: true, 
    rows: 1 
});

 $('.slick-dots').slick({
    infinite: true,    
    slidesToShow: 9,  
    slidesToScroll: 9, 
    prevArrow: '<button type="button" class="slick-prev">Prev</button>',
    nextArrow: '<button type="button" class="slick-next">Next</button>'
 });
